import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteOverlayDocument } from './delete.generated';

export const useDeleteOverlay = (options: ApiOptions<typeof DeleteOverlayDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteOverlayDocument, {
    ...useNotifications(DeleteOverlayDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.overlays.delete_success'),
    }),

    ...options,
  });
};
